import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "w-full bg-black text-white dark:bg-offWhite dark:text-black pt-20 pb-10 px-4 md:px-8 mt-20" };
const _hoisted_2 = { class: "container mx-auto max-w-7xl flex flex-col items-start" };
const _hoisted_3 = { class: "w-full border-b border-white/20 dark:border-black/20 pb-8 mb-12" };
const _hoisted_4 = { class: "font-mono text-accent mb-4 block" };
const _hoisted_5 = { class: "text-6xl md:text-8xl font-bold tracking-tighter uppercase leading-none" };
const _hoisted_6 = { class: "text-outline-white dark:text-outline-black text-transparent stroke-2" };
const _hoisted_7 = { class: "w-full flex flex-col md:flex-row justify-between gap-12" };
const _hoisted_8 = { class: "flex flex-col gap-6" };
const _hoisted_9 = ["href"];
const _hoisted_10 = { class: "flex gap-6 mt-4" };
const _hoisted_11 = ["href"];
const _hoisted_12 = { class: "flex flex-col items-start md:items-end justify-between opacity-60 font-mono text-sm" };
const _hoisted_13 = { class: "mt-2" };
import { computed } from "vue";
import { Icon } from "@iconify/vue";
import { PORTFOLIO_OWNER, CONTENT, SOCIAL_LINKS, CONTACT_EMAIL, } from "../constants";
import { useLanguage } from "../composables/useLanguage";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Footer',
    setup(__props) {
        const { language } = useLanguage();
        const text = computed(() => CONTENT[language.value]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(text.value.sections.contact), 1 /* TEXT */),
                        _createElementVNode("h2", _hoisted_5, [
                            _createTextVNode(_toDisplayString(text.value.footer.line1), 1 /* TEXT */),
                            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                            _createTextVNode(" " + _toDisplayString(text.value.footer.line2) + " ", 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_6, _toDisplayString(text.value.footer.line3), 1 /* TEXT */)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("a", {
                                href: `mailto:${_unref(CONTACT_EMAIL)}`,
                                class: "text-3xl md:text-4xl font-bold hover:text-accent transition-colors underline decoration-accent decoration-4 underline-offset-8"
                            }, _toDisplayString(_unref(CONTACT_EMAIL)), 9 /* TEXT, PROPS */, _hoisted_9),
                            _createElementVNode("div", _hoisted_10, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SOCIAL_LINKS), (link) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                        key: link.name,
                                        href: link.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        class: "p-3 border border-white/20 dark:border-black/20 hover:bg-accent hover:border-accent transition-all rounded-none"
                                    }, [
                                        _createVNode(_unref(Icon), {
                                            icon: link.icon,
                                            class: "w-6 h-6"
                                        }, null, 8 /* PROPS */, ["icon"])
                                    ], 8 /* PROPS */, _hoisted_11));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("p", null, _toDisplayString(text.value.footer.based), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_13, " © " + _toDisplayString(new Date().getFullYear()) + " " + _toDisplayString(_unref(PORTFOLIO_OWNER)) + ". " + _toDisplayString(text.value.footer.rights), 1 /* TEXT */)
                        ])
                    ])
                ])
            ]));
        };
    }
});
